import { Action } from '@ngrx/store'
import { SavedReplyV1 } from '../../../api/api/models/saved-reply-v1'
import { SavedRepliesUIState } from '../reducers/saved-replies.reducer'

export const LOAD_SAVED_REPLIES = '[Saved replies] load'
export const LOAD_SAVED_REPLIES_SUCCESS = '[Saved replies] load success'
export const LOAD_SAVED_REPLIES_FAILURE = '[Saved replies] load failure'

export const CREATE_SAVED_REPLY = '[Saved replies] create'
export const CREATE_SAVED_REPLY_SUCCESS = '[Saved replies] create success'
export const CREATE_SAVED_REPLY_FAILURE = '[Saved replies] create failure'

export const DELETE_SAVED_REPLY = '[Saved replies] delete'
export const DELETE_SAVED_REPLY_SUCCESS = '[Saved replies] delete success'
export const DELETE_SAVED_REPLY_FAILURE = '[Saved replies] delete failure'

export const UPDATE_SAVED_REPLY = '[Saved replies] update'
export const UPDATE_SAVED_REPLY_SUCCESS = '[Saved replies] update success'
export const UPDATE_SAVED_REPLY_FAILURE = '[Saved replies] update failure'

// misc
export const SAVED_REPLIES_CLOSE = '[Saved replies] close'
export const SAVED_REPLIES_TOGGLE = '[Saved replies] toggle'
export const SELECT_SAVED_REPLY = '[Saved replies] select'
export const SET_SAVED_REPLIES_STATE = '[Saved replies] set UI state'
export const SET_SAVED_REPLIES_LEFT_POSITION = '[Saved replies] set left position'

// load
export class LoadSavedReplies implements Action {
  readonly type = LOAD_SAVED_REPLIES
}

export class LoadSavedRepliesSuccess implements Action {
  readonly type = LOAD_SAVED_REPLIES_SUCCESS

  constructor(public payload: { items: SavedReplyV1[] }) {
  }
}

export class LoadSavedRepliesFailure implements Action {
  readonly type = LOAD_SAVED_REPLIES_FAILURE

  constructor(public payload: string) {
  }
}

// create
export class CreateSavedReply implements Action {
  readonly type = CREATE_SAVED_REPLY

  constructor(public payload: Partial<SavedReplyV1>) {
  }
}

export class CreateSavedReplySuccess implements Action {
  readonly type = CREATE_SAVED_REPLY_SUCCESS

  constructor(public payload: SavedReplyV1) {
  }
}

export class CreateSavedReplyFailure implements Action {
  readonly type = CREATE_SAVED_REPLY_FAILURE

  constructor(public payload: string) {
  }
}

// delete
export class DeleteSavedReply implements Action {
  readonly type = DELETE_SAVED_REPLY

  constructor(public payload: SavedReplyV1) {
  }
}

export class DeleteSavedReplySuccess implements Action {
  readonly type = DELETE_SAVED_REPLY_SUCCESS

  constructor(public payload: SavedReplyV1) {
  }
}

export class DeleteSavedReplyFailure implements Action {
  readonly type = DELETE_SAVED_REPLY_FAILURE

  constructor(public payload: string) {
  }
}

// update
export class UpdateSavedReply implements Action {
  readonly type = UPDATE_SAVED_REPLY

  constructor(public payload: SavedReplyV1) {
  }
}

export class UpdateSavedReplySuccess implements Action {
  readonly type = UPDATE_SAVED_REPLY_SUCCESS

  constructor(public payload: SavedReplyV1) {
  }
}

export class UpdateSavedReplyFailure implements Action {
  readonly type = UPDATE_SAVED_REPLY_FAILURE

  constructor(public payload: string) {
  }
}

// misc
export class SavedRepliesClose implements Action {
  readonly type = SAVED_REPLIES_CLOSE
}

export class SavedRepliesToggle implements Action {
  readonly type = SAVED_REPLIES_TOGGLE
}

export class SelectSavedReply implements Action {
  readonly type = SELECT_SAVED_REPLY

  constructor(public payload: {first?: boolean, previous?: boolean, reply?: SavedReplyV1}) {
  }
}

export class SetSavedRepliesState implements Action {
  readonly type = SET_SAVED_REPLIES_STATE

  constructor(public payload: SavedRepliesUIState) {
  }
}

export class SavedRepliesLeftPosition implements Action {
  readonly type = SET_SAVED_REPLIES_LEFT_POSITION

  constructor(public payload: number) {
  }
}

export type SavedRepliesActions =
  LoadSavedReplies
  | LoadSavedRepliesSuccess
  | LoadSavedRepliesFailure
  | CreateSavedReply
  | CreateSavedReplySuccess
  | CreateSavedReplyFailure
  | DeleteSavedReply
  | DeleteSavedReplySuccess
  | DeleteSavedReplyFailure
  | UpdateSavedReply
  | UpdateSavedReplySuccess
  | UpdateSavedReplyFailure
  | SavedRepliesClose
  | SavedRepliesToggle
  | SelectSavedReply
  | SetSavedRepliesState
  | SavedRepliesLeftPosition



// WEBPACK FOOTER //
// ./src/app/chat/store/actions/saved-replies.actions.ts